import React from 'react';
// @ts-ignore
import HighchartsReact from 'highcharts-react-official';
// @ts-ignore
import Highcharts from 'highcharts';
import { DLSListItem, TicketListItem } from '../../../pages/company_operations/time_administration/types';
import { nearestFourthHour } from '../../../utilities/helper';
export interface CategoryChartProps {
    data: any;
    dlsList: Array<DLSListItem>;
}

const CategoryChart: React.FC<CategoryChartProps> = (props: CategoryChartProps) => {
    const [graphSeries, setGraphSeries] = React.useState([] as any)
    React.useEffect(() => {
        //console.log("Pie Chart Props", props);
        let gapTotal: number = 0;
        let durationTotal: number = 0;
        props.dlsList?.forEach((item: DLSListItem) => {
            if (item.ticketList) {
                item.ticketList.forEach((ticket: TicketListItem) => {
                    gapTotal += ticket.gapMinutes;
                    durationTotal += ticket.durationMinutes;
                })
            }
        });
        let final: Array<any> = [{
            name: "Hours",
            type: 'pie',
            data: props.data,
            size: 200,
        }];
        if (gapTotal || durationTotal) {
            final.push({
                name: "Hours",
                type: 'pie',
                size: 100,
                data: [
                    { name: "Gap", selected: false, y: nearestFourthHour(gapTotal), color: "#FE6800" },
                    { name: "Worked", selected: false, y: nearestFourthHour(durationTotal), color: "#008000" }
                ]
            })
        }
        setGraphSeries(final);
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [props.data, props.dlsList])

    // have to flatten the array of objects in order to get gap and worked on the legend to work.
    //console.log(graphSeries)
    let singleGraphSeriesArr: any[] = [];
    //r-18-lint-dj
    //eslint-disable-next-line
    graphSeries.map((graphItem: { data: [{ name: string, y: number, selected: boolean }] }) => {
        //r-18-lint-dj
        //eslint-disable-next-line
        graphItem.data.map((item: { name: string, y: number, selected: boolean }) => {
            singleGraphSeriesArr.push(item)
        })
    })
    //console.log(singleGraphSeriesArr);

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={{
                title: {
                    text: ""
                },
                chart: {
                    plotShadow: false,
                    type: 'pie',
                    className: "w-100 p-1",
                    height: 210,
                    width: 500
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            alignTo: "toPlotEdges",
                            distance: -30,
                            //!!!r-18-dj
                            //@ts-ignore
                            formatter: function () {
                                //console.log("Label formatter", this);
                                //!!!r-18-dj
                                //@ts-ignore
                                return this.point.y || 0;
                            }
                        },
                        showInLegend: true
                    }
                },
                legend: {
                    align: "right",
                    verticalAlign: "middle",
                    layout: "vertical",
                    //!!!r-18-dj
                    //@ts-ignore
                    labelFormatter: function () {
                        // see flattening comment before return
                        //!!!r-18-dj
                        //@ts-ignore
                        const totalHours: number = singleGraphSeriesArr.find((entry: { name: string, y: number, selected: boolean }) => entry.name === this.name)?.y || 0;
                        //!!!r-18-dj
                        //@ts-ignore
                        return `${this.name} (${totalHours} Hrs)`;
                    }
                },
                series: graphSeries,
                colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
                    '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
                credits: {
                    enabled: false
                },
            }}
            allowChartUpdate={true}
            className="w-100 h-100"
        />
    );
}
export default CategoryChart;